import { useState } from 'react';
import { Key } from '@phosphor-icons/react';
import PageHeader from '../../../shared/components/PageHeader';
import PasswordField from './Parts/PasswordField';

type PasswordPageProps = {
  back: () => void;
  onSave: (currentPassword: string, newPassword: string) => Promise<boolean>;
  t: any;
};

export default function PasswordPage({ back, onSave, t }: PasswordPageProps) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [pending, setPending] = useState(false);

  const submit = async (event: any) => {
    event.preventDefault();
    setError('');

    if (newPassword !== confirmation) {
      setError(t.passwordMismatch);
      return;
    }

    setPending(true);
    const saved = await onSave(currentPassword, newPassword);
    if (!saved) setPending(false);
  };

  return (
    <PageHeader
      back={back}
      eyebrow={t.security}
      title={t.changePassword}
      subtitle={t.changePasswordSubtitle}
    >
      <form className="account-card password-card" onSubmit={submit}>
        <PasswordField
          autoComplete="current-password"
          label={t.currentPassword}
          hideLabel={t.hidePassword}
          showLabel={t.showPassword}
          value={currentPassword}
          onChange={setCurrentPassword}
        />
        <PasswordField
          autoComplete="new-password"
          label={t.newPassword}
          hideLabel={t.hidePassword}
          showLabel={t.showPassword}
          value={newPassword}
          onChange={setNewPassword}
        />
        <PasswordField
          autoComplete="new-password"
          label={t.confirmPassword}
          hideLabel={t.hidePassword}
          showLabel={t.showPassword}
          value={confirmation}
          onChange={setConfirmation}
        />
        <small className="password-help">{t.passwordRequirements}</small>
        {error && <div className="form-error">{error}</div>}
        <button className="primary account-save" disabled={pending} type="submit">
          <Key weight="bold" />
          {pending ? t.pleaseWait : t.updatePassword}
        </button>
      </form>
    </PageHeader>
  );
}
